import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export class ItemComponent extends React.Component {
    render() {
        return (_jsx("div", Object.assign({ role: "button" }, this.props, { className: `user-select-none d-inline-block text-white text-center bg-primary bg-gradient rounded bg-opacity-75${this.props.className ? " " + this.props.className : ''}`, style: Object.assign(Object.assign({}, this.props.style), { width: 130, marginRight: 3, MozUserSelect: "none", WebkitUserSelect: "none", msUserSelect: "none" }) })));
    }
}
//# sourceMappingURL=ItemComponent.js.map